import React from 'react';
import PropTypes from 'prop-types';

import OEIconCodes from '../../../lib/oe-icon-codes';
import OEIcon from '../../elements/oe-icon';
import {OEIconButton} from '../../elements/controls/oe-button';
import OETextField from '../../elements/controls/oe-text-field';
import {OEPresetType, OEPresetTypeHelper} from './oe-preset-model';

export default class OEPresetTableCell extends React.PureComponent {

    constructor(props)  {
        super(props); 

        this.onTextFieldRef = this.onTextFieldRef.bind(this);

        this.onDumpBtnPressed = this.onDumpBtnPressed.bind(this);
        this.onNameChanged = this.onNameChanged.bind(this);
        this.onApplyBtnPressed = this.onApplyBtnPressed.bind(this);
    }

    componentDidMount() {
        if(this.props.checkIfAdded && this.props.checkIfAdded(this.props.id)) {
            this.textFieldRef.focus();
        }
    }

    onTextFieldRef(ref) {
        this.textFieldRef = ref;
    }

    render()    {
        let typeAsString = OEPresetType.toString(this.props.type);
        let applyEnabled = typeAsString && this.props.controllerUIEnabled[typeAsString];

        return(
            <div className="preset-cell">
                <div className="content">

                    <OEIconButton
                        className="transparent-btn dump-btn"
                        icon={OEIconCodes.preset.dump}
                        disabled={!this.props.uiEnabled}
                        onPressed={this.onDumpBtnPressed}
                    />

                    <OETextField
                        ref={this.onTextFieldRef}
                        className="std-label-border-color"
                        clearButton={false}
                        value={this.props.name}
                        onChange={this.onNameChanged}
                    />

                    {!this.props.showIcon && typeAsString && OEIconCodes.preset.type[typeAsString] ? null : <OEIcon code={OEIconCodes.preset.type[typeAsString]}/>}

                    <OEIconButton
                        className="transparent-btn apply-btn"
                        icon={OEIconCodes.preset.apply}
                        disabled={!applyEnabled}
                        onPressed={this.onApplyBtnPressed}
                    />

                </div>

                {this.props.showSeparator ? <div className="std-separator-border-color separator"/> : null}

            </div>
        );
    }
    
    onDumpBtnPressed()  {
        if(this.props.onDumpBtnPressed)  this.props.onDumpBtnPressed(this.props.id);
    }

    onNameChanged(sender, value)  {
        if(this.props.onNameChanged)  this.props.onNameChanged(this.props.id, value);
    }

    onApplyBtnPressed()   {
        if(this.props.onApplyBtnPressed)  this.props.onApplyBtnPressed(this.props.id);
    }
}

OEPresetTableCell.defaultProps = {
    uiEnabled:                  true,
    controllerUIEnabled: {
        note:                   false,
        camera:                 false,
        cut:                    false,
        color:                  false,
        components:             false
    },
    selected:                   false
};

OEPresetTableCell.propTypes = {
    id:                         PropTypes.number,
    name:                       PropTypes.string,
    type:                       OEPresetTypeHelper.presetTypeNumberDecl,
    uiEnabled:                  PropTypes.bool,
    controllerUIEnabled:  PropTypes.shape({
        note:                   PropTypes.bool,
        camera:                 PropTypes.bool,
        cut:                    PropTypes.bool,
        color:                  PropTypes.bool,
        components:             PropTypes.bool
    }),
    selected:                   PropTypes.bool,
    showSeparator:              PropTypes.bool,
    showIcon:                   PropTypes.bool,
    onSelectionChange:          PropTypes.func,
    onDumpBtnPressed:           PropTypes.func,
    onNameChanged:              PropTypes.func,
    onApplyBtnPressed:          PropTypes.func,
    checkIfAdded:               PropTypes.func
};
